// extracted by mini-css-extract-plugin
export var container = "_8w-0";